import DashboardLayout from "./Components/Invoice/Dashboard";
export default function Subscriptions() {
  return (
    <DashboardLayout>
    <div>
      <h1 className="text-2xl font-bold">All Subscriptions</h1>
      <p>Here you will display saved subscriptions from backend.</p>
    </div>
    </DashboardLayout>
  );
}